import { action, observable, makeObservable, runInAction } from "mobx";
import api from "../../../../api";
import CommonStore from "../../common_store";

class XPoolStore {
  //搜索表单字段
  @observable searchForm: powerSearchData = {};
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.manageXPoolPage();
    },
  };
  commonStore: CommonStore;
  constructor(baseStore: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }

  setSearchForm(obj: powerSearchData) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }

  @action
  manageXPoolPage() {
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.xPoolAllocationApi
      .manageXPoolPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          res.data.records.forEach((item: any) => {
            //添加起呼A池的值
            item.callInitializerNumberPool = item.callInitializerNumberPoolIdNames
              .map((list: any) => list.name)
              .join(",");
          });
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
          this.commonStore.getPagePermission("xpool_management");
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

}

export default XPoolStore;
